import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

type PaginationPropsType = {
  pagination: any;
  onChange: (page: number, size: number) => void;
};

const Pagination = (props: PaginationPropsType) => {
  const { onChange, pagination } = props;
  const { t } = useTranslation();
  const currentPage = Number(pagination.getIn(["number"])) || 0;
  const pageSize = Number(pagination.getIn(["size"])) || 10;
  const totalPages = Number(pagination.getIn(["totalPages"])) || 1;
  const totalElements = Number(pagination.getIn(["totalElements"])) || 0;
  const cssPrev = currentPage > 0 ? "text-gray-900" : "text-gray-300";
  const cssNext = currentPage + 1 < totalPages ? "text-gray-900" : "text-gray-300";

  return (
    <nav className="flex items-center justify-between bg-white space-x-2" aria-label="Pagination">
      <div className="hidden sm:block space-x-1">
        <div className="flex items-center text-sm text-gray-700 space-x-1">
          <span className="font-medium">{currentPage + 1}</span>
          <span className="font-medium">-</span>
          <span className="font-medium">{totalPages}</span>
          <span className="font-medium">{t("of")}</span>
          <span className="font-medium">
            {totalElements} {t("records")}
          </span>
        </div>
      </div>
      <div className="flex flex-1 sm:justify-start space-x-2 cursor-pointer">
        <div
          onClick={() => {
            if (currentPage > 0) {
              onChange(currentPage - 1, pageSize);
            }
          }}
          className={`${cssPrev}`}
        >
          <ChevronLeftIcon className={"w-5"} />
        </div>
        <div
          onClick={() => {
            if (currentPage >= 0 && currentPage < totalPages - 1) {
              onChange(currentPage + 1, pageSize);
            }
          }}
          className={`${cssNext}`}
        >
          <ChevronRightIcon className={"w-5"} />
        </div>
      </div>
    </nav>
  );
};

export default Pagination;
